"use strict";

export function initInScope ($scope) {
    $scope.find('.js-collapsing-radio__input').on('change',function (e) {
        if ($(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__input--toggler').prop('checked')) {
            $(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__add').removeAttr('hidden');
        } else if ($(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__input--toggle-persons').prop('checked')) {
            $(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__add').removeAttr('hidden');
        } else {
            $(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__add').attr('hidden','hidden');
            $(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__add:not(.js-collapsing-radio__add--keep-values)').find('input').val('').removeClass('has-value');
            $(this).closest('.js-collapsing-radio').find('.js-collapsing-radio__add:not(.js-collapsing-radio__add--keep-values)').find('.form-group').removeClass('has-value');
        }
    });
}